(function($, undefined) {

    'use strict';
    var currPage;
    var toggleProfilesBtn;
    var profileBtn;
    var navProfilesBtn;
    var respDetectionSmScreen;
	var respDetectionPhScreen;
    var win;
    var header;
   
    var toggleProfilesWin = function(e){
        var active = navProfilesBtn.hasClass("active");
        
        if(active){
            checkClickMenuProfil(e);
        }
        else{
            $('.site-nav').removeClass('overflow-y-auto');
            if (respDetectionSmScreen.css('visibility') !== 'visible') {
                win.slideDown(function() {
                    $(this).addClass('open').removeAttr('style');
                });
            } else {
                setTimeout(function() {
                    win.addClass('open');
                }, 300);

                if (!$('body').hasClass('no-scroll')) {
                    header.toggleScroll();
                }
            }

            navProfilesBtn.addClass("active");
        }
    };
    
    var closeProfilesWindow = function() {
        if ($('body').hasClass('no-scroll') && (respDetectionPhScreen.css('visibility') === 'hidden' || !$('header').hasClass('menu-open'))) {
            header.toggleScroll();
        }

        if (respDetectionSmScreen.css('visibility') !== 'visible') {
            win.slideUp(function() {
                $(this).removeClass('open').removeAttr('style');
            });
        } else {
            win.removeClass('open');
        }

        setTimeout(function() {
            $('.site-nav').addClass('overflow-y-auto');
        }, 300);
        navProfilesBtn.removeClass("active");
    };

    var checkClickMenuProfil = function(event){
        if ((!$(event.target).closest(win).length || $(event.target).closest(toggleProfilesBtn).length) && win.hasClass('open')) {
            closeProfilesWindow();
        }
    };

    var logAs = function(){
        var active = $(this).hasClass("active");
        
        if(!active){
            $(this).find("form").submit();
        }
    };

    var init = function(page) {
        currPage = $(page);
        header = Fw.modules.models().header;
        respDetectionSmScreen = $('.responsive-detector-sm',page);
        respDetectionPhScreen = $('.responsive-detector',page);

        /* Toggle My Profiles window*/
        win = $(".my-profiles-window");
        navProfilesBtn = $('.logged-nav-item-profiles');
        navProfilesBtn.on("click",toggleProfilesWin);
        toggleProfilesBtn = $(".open-profiles-window-btn",page);
        //toggleProfilesBtn.on("click",toggleProfilesWin);
        
        /* Log as My Profiles window*/
        profileBtn = $(".my-profiles-one-line:not(.disabled)",page);
        profileBtn.on("click",logAs);
        
        $(document).on('click',checkClickMenuProfil);
    };

    $(window).on("load",function(){
        init();        
    });

})(jQuery);